import * as React from "react";
import { forwardRef } from "react";
const SvgReplyIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 17, viewBox: "0 0 16 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "el:share-alt" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M6.45447 2.5V5.6245C9.12683 5.62458 14 5.65572 14 14.5C13.4475 8.5857 10.9094 8.54851 6.45447 8.54845V11.9606L2 7.22992L6.45447 2.5Z" })));
const ForwardRef = forwardRef(SvgReplyIcon);
export { ForwardRef as ReactComponent };
